module.exports = __webpack_public_path__ + "img/symbol_4.cc128571.png";